<template>
  <page>
        <form>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
              </v-expansion-panel-header>
            <v-expansion-panel-content>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex lg4 xs12>
                <v-text-field
                  v-model="form.noOfYr"
                  :label="labels.noOfYr"
                  :error-messages="errors.collect('noOfYr')"
                  :data-vv-as="labels.noOfYr"
                  data-vv-name="noOfYr"
                  v-validate="'required|greaterThanOne'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                  <v-text-field
                    v-model="form.acctPeriodFrom"
                    :label="labels.acctPeriodFrom"
                    :error-messages="errors.collect('acctPeriodFrom')"
                    :data-vv-as="labels.acctPeriodFrom"
                    data-vv-name="acctPeriodFrom"
                    v-validate="acctMonthFromValidation"
                  ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.acctPeriodTo"
                  :label="labels.acctPeriodTo"
                  :error-messages="errors.collect('acctPeriodTo')"
                  :data-vv-as="labels.acctPeriodTo"
                  data-vv-name="acctPeriodTo"
                  v-validate="acctMonthToValidation"
                ></v-text-field>
              </v-flex>
              </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="form.acctNoFrom"
                  :label="labels.acctNoFrom"
                  :error-messages="errors.collect('acctNoFrom')"
                  data-vv-name="acctNoFrom"
                  :data-vv-as="labels.acctNoFrom"
                  append-icon="mdi-magnify"
                  readonly
                @click:append="
                  showIntermediaryHelpList = true
                  selectedInterField = 'acctNoFrom'
                "
                clearable
                v-validate="acctNoFromValidate()"
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                v-model="form.acctNoTo"
                :label="labels.acctNoTo"
                :error-messages="errors.collect('acctNoTo')"
                data-vv-name="acctNoTo"
                :data-vv-as="labels.acctNoTo"
                append-icon="mdi-magnify"
                readonly
                @click:append="
                  showIntermediaryHelpList = true
                  selectedInterField = 'acctNoTo'
                "
                clearable
                v-validate="acctNoToValidate()"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <!-- Business Source -->
                <v-text-field
                  v-model="form.busSrc"
                  :label="labels.busSrc"
                  :error-messages="errors.collect('busSrc')"
                  :data-vv-as="labels.busSrc"
                  data-vv-name="busSrc"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('busSrc')"
                  readonly
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.insdRef"
                  :label="labels.insdRef"
                  :error-messages="errors.collect('insdRef')"
                  :data-vv-as="labels.insdRef"
                  data-vv-name="insdRef"
                  append-icon="mdi-magnify"
                  @click:append="multiInsuredHelpList = true"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <!-- Business Class -->
                <v-text-field
                  v-model="form.busCls"
                  :label="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                  :data-vv-as="labels.busCls"
                  data-vv-name="busCls"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('busCls')"
                  readonly
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-select v-model="form.rptType" :items="rptTypeList" :label="labels.rptType" data-vv-name="rptType" :data-vv-as="labels.rptType" :error-messages="errors.collect('rptType')"
                    v-validate="'required'"  item-text="label" item-value="value"/>
              </v-flex>
            </v-layout>
          </v-container>
          </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
        </form>
          <v-container fluid grid-list-lg>
            <v-flex xs12>
              <v-checkbox
                v-model="form.prtRptRunTime"
                :label="labels.prtRptRunTime"
                data-vv-name="prtRptRunTime"
                :data-vv-as="labels.prtRptRunTime"
              />
            </v-flex>
            <v-layout row wrap>
              <v-flex xs12 class="pt-3">
                <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ labels.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="form.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
    <v-dialog v-model="multiBusClsList" width="900px" persistent>
      <multi-bus-cls-help-list :busCls="form.busCls" @close="multiBusClsList = false" @doAssign="doAssignMulti($event)"></multi-bus-cls-help-list>
    </v-dialog>
        <v-dialog v-model="multiBusSrcList" width="900px" persistent>
      <multi-bus-src-help-list :busSrc="form.busSrc" @close="multiBusSrcList = false" @doAssign="doAssignMulti($event)"></multi-bus-src-help-list>
    </v-dialog>
    <v-dialog v-model="showIntermediaryHelpList" width="900px" persistent>
      <intermediary-help-list :interGrps="'10,11,13,20,25'" @close="showIntermediaryHelpList = false" headerInfo="default" @assign-intermediary-data="assignInterInfo"></intermediary-help-list>
    </v-dialog>
    <v-dialog v-model="multiInsuredHelpList" width="900px" persistent>
      <insured-filter :menu="menu" @close="multiInsuredHelpList = false" @doAssign="doAssignInsdRef($event)"></insured-filter>
    </v-dialog>
    <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-information</v-icon>
            <v-toolbar-title>System Information</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <span class="info-dialog-msg-header">Oops something went wrong...</span>
              <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import MultiBusSrcHelpList from '@/components/core/common/dialog/MultiBusSrcHelpList.vue'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import InsuredFilter from '@/components/core/common/dialog/InsuredFilter.vue'

export default {
  data() {
    return {
      labels: {
        noOfYr: 'Number of Years',
        acctPeriodFrom: 'Accounting Period From',
        acctPeriodTo: 'Accounting Period To',
        acctNoFrom: 'Account No From',
        acctNoTo: 'Account No To',
        insdRef: 'Insured',
        busCls: 'Business Class',
        busSrc: 'Business Source',
        rptType: 'Report Type',
        prtRptRunTime: 'Print Runtime Parameters',
        format: 'Export Format',
        export: 'Export to'
      },
      form: {
        noOfYr: 1,
        acctPeriodFrom: '',
        acctPeriodTo: '',
        acctNoFrom: '',
        acctNoTo: '',
        insdRef: 'All',
        busCls: 'All',
        busSrc: 'All',
        rptType: 'D',
        prtRptRunTime: true,
        format: 'PDF'
      },
      menu: {},
      supportedFormat: [],
      insdRefList: [],
      submitting: false,
      showErrorDialog: false,
      rptTypeList: [
        { label: 'Default', value: 'D' },
        { label: 'By Agent', value: 'A' },
        { label: 'By Business Source', value: 'B' }
      ],
      mode: '',
      multiBusClsList: false,
      multiBusSrcList: false,
      multiInsuredHelpList: false,
      showIntermediaryHelpList: false,
      selectedInterField: undefined,
      panel: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    acctMonthFromValidation() {
      if (this.form.acctPeriodFrom !== '') {
        let validation = 'required|acctPeriodValidate|acctMthFrom:' + this.form.acctPeriodTo
        return validation
      } else {
        return 'required'
      }
    },
    acctMonthToValidation() {
      if (this.form.acctPeriodTo !== '') {
        return 'required|acctPeriodValidate|acctMthTo:' + this.form.acctPeriodFrom
      } else {
        return 'required'
      }
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$validator.extend('greaterThanOne', {
      validate: value => {
        return parseFloat(value) >= 1 && parseFloat(value) <= 9
      },
      getMessage(field, args) {
        return 'Must be 1 to 9'
      }
    })
    this.$validator.extend('acctPeriodValidate', {
      validate: value => {
        return parseFloat(value) >= 1 && parseFloat(value) <= 12
      },
      getMessage(field, args) {
        return 'Must be 1 to 12'
      }
    })
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.proByACYear
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      switch (fieldName) {
        case 'busCls':
          this.multiBusClsList = true
          break
        case 'busSrc':
          this.multiBusSrcList = true
          break
      }
    },
    async doAssignMulti(Obj) {
      switch (this.mode) {
        case 'busCls':
          this.form.busCls = []
          this.form.busCls = Obj.finalSelectedItems.toString()
          break
        case 'busSrc':
          this.form.busSrc = []
          this.form.busSrc = Obj.finalSelectedItems.toString()
          break
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      if (this.form.format === 'PDF' && this.form.acctNoFrom === '' && this.form.acctNoTo === '') {
        this.displayMsg('acctNoPDF')
      } else {
        const apiURI = this.menu.exportProByAcctYr
        if (apiURI) {
          try {
            this.submitting = true
            await this.$http.post(apiURI, this.form)
            this.submitting = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.submitting = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async assignInterInfo(data) {
      switch (this.selectedInterField) {
        case 'acctNoFrom':
          this.form.acctNoFrom = data.inter
          this.$validator.validate('acctNoFrom')
          break
        case 'acctNoTo':
          this.form.acctNoTo = data.inter
          this.$validator.validate('acctNoTo')
          break
        default:
      }
    },
    acctNoValidate(field) {
      if (field === 'acctNoFrom') {
        if (this.form.acctNoTo === '') {
          return ''
        } else {
          if (this.form.acctNoTo) {
            return 'acctNoRangeFrom:' + this.form.acctNoTo
          } else {
            return ''
          }
        }
      } else {
        if (this.form.acctNoFrom) {
          return 'acctNoRangeTo:' + this.form.acctNoFrom
        } else {
          return ''
        }
        // }
      }
    },
    async doAssignInsdRef(Obj) {
      this.form.insdRef = []
      this.form.insdRef = Obj.finalSelectedItems.toString()
    },
    acctNoFromValidate() {
      if ((this.form.acctNoFrom === null && this.form.acctNoTo !== null) || (this.form.acctNoFrom === '' && this.form.acctNoTo !== '')) {
        return 'required'
      } else {
        return 'acctNoRangeFrom:' + this.form.acctNoTo
      }
    },
    acctNoToValidate() {
      if ((this.form.acctNoFrom !== null && this.form.acctNoTo === null) || (this.form.acctNoFrom !== '' && this.form.acctNoTo === '')) {
        return 'required'
      } else {
        return 'acctNoRangeTo:' + this.form.acctNoFrom
      }
    },
    displayMsg(param) {
      var errMsg
      var messages = []
      if (param === 'acctNoPDF') {
        messages.push({ message: 'Must update Account No. Range for PDF format', type: 'ERROR' })
        this.showErrorDialog = true
      }
      if (messages.length > 0) {
        errMsg = { messages }
        this.message(errMsg)
        this.fieldMessage(errMsg)
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('acctMthFrom', {
      getMessage(field, args) {
        return 'Accounting Month From must be equal or greater than Accounting Month To'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctMthFrom = args[0]
        if (parseInt(value) > parseInt(acctMthFrom)) {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('acctMthTo', {
      getMessage(field, args) {
        return 'Accounting Month To must be equal or greater than Accounting Month From'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctMthTo = args[0]
        if (parseInt(acctMthTo) > parseInt(value)) {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('acctNoRangeFrom', {
      getMessage: (field, args) => {
        return field + ' must less than or equal To Account No.'
      },
      validate: (value, args) => {
        if (value > args) {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('acctNoRangeTo', {
      getMessage: (field, args) => {
        return field + ' must greater than or equal From Account No.'
      },
      validate: (value, args) => {
        if (value < args) {
          return false
        } else {
          return true
        }
      }
    })
  },
  mixins: [MessageMixin],
  components: {
    MultiBusClsHelpList,
    IntermediaryHelpList,
    InsuredFilter,
    MultiBusSrcHelpList
  }
}
</script>
